// extracted by mini-css-extract-plugin
export default {"dutyContainer":"Duties_dutyContainer__8rs6p","header":"Duties_header__Mdx3L","duties":"Duties_duties__0ZSAT"};